import script from "./CheckoutForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutForm.vue?vue&type=script&setup=true&lang=ts"

import "../../assets/css/purchase.css?vue&type=style&index=0&id=6a3ca40b&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3ca40b"]])

export default __exports__